//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defaultBlockProps, getReviews } from "~/helpers/data";

export default {
    name: "BowReviewsList",

    props: {
        ...defaultBlockProps,

        reviews: {
            default: null,
            type: Array,
        },
    },

    data: () => ({
        list: [],
    }),

    async fetch() {
        if (this.reviews && this.reviews.length > 0) {
            this.list = await getReviews(this.$axios, this.reviews);
        }
    },

    mounted() {
        this.$nuxt.$emit("update-locomotive");
    },
};
